export default {
  X: 'x',
  Y: 'y',
  UP: 'UP',
  DOWN: 'DOWN'
};